import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    pupilas: [],
  },

  getters: {
    getReflejosOsteotendinosos: (state) => state.pupilas,
  },

  mutations: {
    SET_REFLEJOS_OSTEOTENDINOSOS(state, pupilas) {
      state.pupilas = pupilas;
    },
  },

  actions: {
    async fetchReflejosOsteotendinosos({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catReflejosOsteotendinosos')
        .then((response) => {
          commit('SET_REFLEJOS_OSTEOTENDINOSOS', response.data.data);
        });
    },
  },
};
